import { render } from "./UserPerformanceDetails.vue?vue&type=template&id=056abf98&scoped=true"
import script from "./UserPerformanceDetails.vue?vue&type=script&lang=js"
export * from "./UserPerformanceDetails.vue?vue&type=script&lang=js"

import "./UserPerformanceDetails.vue?vue&type=style&index=0&id=056abf98&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-056abf98"]])

export default __exports__